"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {
    cutDevice: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      package: [6, 22, 38, 46],
      fee_plan: {
        zhuang_fee_plan: {}
      },
      business_mode: {},
      card: {},
      form: {
        wash_laundry_fee_plan: []
      },
      form_key: {
        wash_laundry_fee_plan: '',
        free_rent_minutes: '',
        expired_bao_cost_price: '',
        limit_deposit_amount_min: '',
        limit_deposit_amount_max: '',
        expired_thread_cost_price: '',
        kc_cdb_cost_price: '',
        mc_cdb_cost_price: '',
        kc_lymmx_cost_price: '',
        mc_lymmx_cost_price: '',
        kc_mmx_cost_price: '',
        mc_mmx_cost_price: '',
        low_wxcredit_switch: 0,
        low_wxcredit_percent_bao: 0,
        low_zfbcredit_switch: 0,
        low_zfbcredit_percent_bao: 0
      }
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      var deviceNameObj = this.$store.state.user.deviceNameObj;
      return deviceNameObj;
    }
  },
  mounted: function mounted() {
    this.setInfo();
    this.getMemberCard();
  },
  methods: {
    /**
     * 获取信息
     */
    setInfo: function setInfo() {
      var _this = this;
      this.$get('agentapi/get_partner_config', {}).then(function (res) {
        var params = {};
        for (var i in _this.form_key) {
          params[i] = res[i];
        }
        _this.form = params;
        var goods_key = _this.config.goods_key,
          fee_xcx = _this.config.fee_xcx,
          fee_plan = {};
        for (var i in goods_key) {
          if (res["default_".concat(goods_key[i], "_limit_setting")]) {
            fee_plan["default_".concat(goods_key[i], "_limit_setting")] = res["default_".concat(goods_key[i], "_limit_setting")];
          }
          if (res["".concat(goods_key[i], "_buy_goods_fee")]) {
            fee_plan["".concat(goods_key[i], "_buy_goods_fee")] = res["".concat(goods_key[i], "_buy_goods_fee")];
          }
          var goods_key_fee = fee_xcx[goods_key[i]] || fee_xcx.default;
          for (var key in goods_key_fee) {
            if (res["".concat(goods_key[i], "_fund_fee_plan").concat(key)]) {
              fee_plan["".concat(goods_key[i], "_fund_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fund_fee_plan").concat(key)];
            }
            if (res["".concat(goods_key[i], "_fee_plan").concat(key)]) {
              fee_plan["".concat(goods_key[i], "_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fee_plan").concat(key)];
            }
          }
        }
        if (fee_plan.zhuang_fee_plan) {
          Object.values(fee_plan.zhuang_fee_plan.plan).map(function (item) {
            var n = parseInt(item.value) + 1;
            return item.rent_zhuang_unit_power_max = fee_plan.zhuang_fee_plan.plan[n] ? parseInt(fee_plan.zhuang_fee_plan.plan[n].rent_zhuang_unit_power_min) - 1 : _this.config.zhuang_power_max;
          });
        }
        console.log(fee_plan);
        _this.fee_plan = fee_plan;
        _this.business_mode = res.business_mode;
      });
    },
    /**
     * 会员卡信息
     */
    getMemberCard: function getMemberCard() {
      var _this2 = this;
      var card = {};
      this.$get('agentapi/system/member_card_setting', {}).then(function (res) {
        card = res.default_memebr_card_setting.std_zhuang;
        card.member_card_switch = res.member_card_switch;
        _this2.card = card;
      });
    },
    /**
     * 提交会员卡信息
     */
    postCard: function postCard() {
      var _this3 = this;
      var params = this.card;
      params.type = params.depend_type;
      // 【操作埋点】2026-05-25 pc_setting_update_1 会员卡设置
      this.$post('agentapi/system/member_card_setting', params).then(function (res) {
        _this3.$settingReport.reportSettingUpdate('member_card_setting', '会员卡设置', null, params);
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
        _this3.$store.dispatch('user/getPlatformConfig');
      });
    },
    /**
     * 输入最大功率
     */
    setPowerMax: function setPowerMax(item) {
      var n = parseInt(item.value) + 1;
      this.fee_plan.zhuang_fee_plan.plan[n].rent_zhuang_unit_power_min = parseInt(item.rent_zhuang_unit_power_max) + 1;
    },
    onSubmit: function onSubmit(device) {
      var _this4 = this;
      var params = {},
        url = '',
        fee_plan = this.fee_plan,
        goods_key = this.config.goods_key,
        fee_xcx = this.config.fee_xcx;
      if (device == 0) {
        url = 'agentapi/system/save_partner_baoing_setting';
        params = this.form;
      } else if (device == 1) {
        url = 'agentapi/system/save_partner_threading_setting';
        params.expired_thread_cost_price = this.form.expired_thread_cost_price;
        params.mc_mmx_cost_price = this.form.mc_mmx_cost_price;
        params.kc_mmx_cost_price = this.form.kc_mmx_cost_price;
        params.mc_lymmx_cost_price = this.form.mc_lymmx_cost_price;
        params.kc_lymmx_cost_price = this.form.kc_lymmx_cost_price;
        params.store_fee_plan_reset = this.form.store_fee_plan_reset;
      } else if (device == 2) {
        url = 'agentapi/system/save_partner_massaging_setting';
        for (var i in fee_plan.zhen_fee_plan) {
          var plan = fee_plan.zhen_fee_plan[i];
          params["rent_major_title_".concat(plan.value)] = plan.rent_major_title;
          params["rent_is_show_".concat(plan.value)] = plan.rent_is_show;
          params["rent_major_fee_".concat(plan.value)] = plan.rent_major_fee;
          params["rent_major_unit_".concat(plan.value)] = plan.rent_major_unit;
          params["rent_attach_unit_".concat(plan.value)] = plan.rent_attach_unit;
        }
      } else if (device == 4) {
        url = 'agentapi/system/save_partner_washing_setting';
        for (var i in fee_plan.wash_fee_plan) {
          var _plan = fee_plan.wash_fee_plan[i];
          params["rent_wash_unit_show_".concat(_plan.value)] = _plan.is_show;
          params["rent_wash_unit_fee_".concat(_plan.value)] = _plan.money;
          params["rent_wash_unit_minute_".concat(_plan.value)] = _plan.time;
          params["rent_wash_unit_name_".concat(_plan.value)] = _plan.name;
        }
        for (var i in this.form.wash_laundry_fee_plan) {
          var laundy = this.form.wash_laundry_fee_plan[i];
          params["rent_laundry_unit_show_".concat(laundy.value)] = laundy.is_show;
          params["rent_laundry_unit_fee_".concat(laundy.value)] = laundy.money;
        }
      } else if (device == 3) {
        url = 'agentapi/system/save_partner_zhuanging_setting';
        params = fee_plan.zhuang_fee_plan;
        for (var i in params.plan) {
          var _plan2 = params.plan[i];
          params["rent_zhuang_unit_fee_".concat(_plan2.value)] = _plan2.rent_zhuang_unit_fee;
          params["rent_zhuang_unit_power_min_".concat(_plan2.value)] = _plan2.rent_zhuang_unit_power_min;
        }
        delete params.plan;
      } else if (device == 6) {
        url = 'agentapi/system/save_partner_blowing_setting';
        for (var i in fee_plan.blower_fee_plan) {
          var _plan3 = fee_plan.blower_fee_plan[i];
          params["rent_blower_unit_minute_".concat(_plan3.value)] = _plan3.rent_blower_unit_minute;
          params["rent_blower_unit_fee_".concat(_plan3.value)] = _plan3.rent_blower_unit_fee;
        }
      } else if (device == 7) {
        url = 'agentapi/system/save_partner_condoming_setting';
        for (var i in fee_plan.condom_fee_plan) {
          var _plan4 = fee_plan.condom_fee_plan[i];
          params["condom_rent_unit_hour_".concat(_plan4.value)] = _plan4.rent_unit_hour;
          params["condom_rent_unit_fee_".concat(_plan4.value)] = _plan4.rent_unit_fee;
        }
        params.expired_condom_cost_price = this.form.expired_condom_cost_price;
      } else if (device == 8) {
        url = 'agentapi/system/save_partner_humidifiering_setting';
      }
      var goods_key_fee = fee_xcx[goods_key[device]] || fee_xcx.default;
      for (var key in goods_key_fee) {
        if (fee_plan["".concat(goods_key[device], "_fund_fee_plan").concat(key)]) {
          params["".concat(goods_key[device], "_fund_fee_plan").concat(key)] = fee_plan["".concat(goods_key[device], "_fund_fee_plan").concat(key)];
        }
        if (fee_plan["".concat(goods_key[device], "_fee_plan").concat(key)]) {
          params["".concat(goods_key[device], "_fee_plan").concat(key)] = fee_plan["".concat(goods_key[device], "_fee_plan").concat(key)];
        }
        if (fee_plan["".concat(goods_key[device], "_buy_goods_fee")]) {
          params["".concat(goods_key[device], "_buy_goods_fee")] = fee_plan["".concat(goods_key[device], "_buy_goods_fee")];
        }
        if (key && this.business_mode["std_".concat(goods_key[device]).concat(key)]) {
          params["".concat(goods_key[device], "_business_mode").concat(key)] = this.business_mode["std_".concat(goods_key[device]).concat(key)];
        }
      }
      if (fee_plan["default_".concat(goods_key[device], "_limit_setting")]) {
        params = Object.assign(params, fee_plan["default_".concat(goods_key[device], "_limit_setting")]);
      }
      if (this.business_mode["std_".concat(this.config.goods_key[device])]) {
        var stc = this.business_mode["std_".concat(this.config.goods_key[device])];
        params = Object.assign(stc, params);
      }
      console.log(params);
      // 【操作埋点】2026-05-25 pc_setting_update_1 计费/业务配置保存
      this.$post(url, params).then(function (res) {
        _this4.$message({
          message: '提交成功',
          type: 'success'
        });
        _this4.$store.dispatch('user/getPlatformConfig');
        _this4.$settingReport.reportSettingUpdate(url.split('/').pop(),
        // 配置键（接口名）
        device == 0 ? '默认设置' : "".concat(_this4.deviceNameObj[device], "\u8BA1\u8D39\u8BBE\u7F6E"),
        // 配置名称
        null,
        // 原值（可根据需要记录）
        params // 新值
        );
      });
    }
  }
};